/**
 * Centralized Constants & Registries
 */
export const Constants = {
    Http: Object.freeze({
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE'
    }),
    Formats: Object.freeze({
        DATE: 'MM/DD/YYYY',
        DATE_TIME: 'MM/DD/YYYY HH:mm',
        ISO: 'YYYY-MM-DD'
    }),
    Currency: Object.freeze({
        PHP: '₱',
        USD: '$',
        EUR: '€'
    }),
    Actions: Object.freeze({
        VIEW: 'view',
        EDIT: 'edit',
        DELETE: 'delete',
        DOWNLOAD: 'download',
        UPLOAD: 'upload',
        REFRESH: 'refresh',
        APPROVE: 'approve',
        REJECT: 'reject',
        ENVELOPE: 'envelope'
    }),
    Theme: Object.freeze({
        SUCCESS: 'success',
        WARNING: 'warning',
        DANGER: 'danger',
        INFO: 'info',
        SECONDARY: 'secondary',
        PRIMARY: 'primary'
    }),
    Icons: Object.freeze({
        CHECK: 'bi-check-circle',
        CLOCK: 'bi-clock',
        WARNING: 'bi-exclamation-triangle',
        VIEW: 'bi-eye',
        EDIT: 'bi-pencil',
        DELETE: 'bi-trash',
        PRINT: 'bi-printer',
        DOWNLOAD: 'bi-download',
        UPLOAD: 'bi-upload',
        REFRESH: 'bi-arrow-clockwise',
        SEARCH: 'bi-search',
        ADD: 'bi-plus-lg',
        LAYOUT: 'bi-layout-three-columns',
        APPROVE: 'bi-hand-thumbs-up',
        REJECT: 'bi-hand-thumbs-down',
        ENVELOPE: 'bi-envelope-at'
    }),
    Align: Object.freeze({
        LEFT: 'text-left',
        CENTER: 'text-center',
        RIGHT: 'text-right'
    }),
    Selection: Object.freeze({
        SINGLE: 'single',
        MULTI: 'multi',
        NONE: 'none'
    }),
    Scope: Object.freeze({
        ALL: 'all',
        FILTERED: 'filtered',
        VISIBLE: 'visible',
        PAGE: 'page',
        CURRENT_PAGE: 'current-page',
        SELECTED: 'selected'
    }),
    Events: Object.freeze({
        CLICK: 'click',
        CHANGE: 'change',
        INPUT: 'input',
        KEYUP: 'keyup'
    }),
    Buttons: Object.freeze({
        CSV: 'csv',
        EXCEL: 'excel',
        PDF: 'pdf',
        PRINT: 'print',
        COPY: 'copy',
        COLVIS: 'colvis'
    }),
    FilterType: Object.freeze({
        TEXT: 'text',
        RANGE: 'range',
        DATE_RANGE: 'date-range',
        SELECT: 'select'
    }),
    UI: Object.freeze({
        POPOVER_WIDTH: 250,
        Z_INDEX: 2000,
        SAFE_MARGIN: 15
    }),
    /**
     * Resolves a theme name or hex color to a valid CSS color.
     */
    resolveColor: (color) => {
        if (!color) return '#64748b';
        if (color.startsWith('#') || color.startsWith('rgb') || color.startsWith('var')) return color;
        
        const theme = String(color).toLowerCase();

        // 1. Try GenericModal resolution
        if (window.GenericModal && window.GenericModal.types && window.GenericModal.types[theme]) {
            return window.GenericModal.types[theme].color;
        }

        // 2. Internal fallback palette matching DataTableWrapper.css tokens
        const palette = {
            success: '#15803d',
            warning: '#b45309',
            danger:  '#b91c1c',
            info:    '#1d4ed8',
            secondary: '#64748b',
            primary: '#ff9447'
        };

        return palette[theme] || color;
    }
};

/**
 * Global Registry for Advanced Filtering
 * Maps DOM table elements to their respective DataTableAdapter instances
 */
export const _adapterRegistry = new Map();
